module.exports = __webpack_public_path__ + "static/media/moodFace.187021cb.svg";